export default {
  title: 'Sistema de Gerenciamento de Tributos',
  formatoNumerico: {
    n2: "#,##0.00",
    moeda: "R$ #,##0.00"
  }
};
